$shm_dashboard_app_dashboard_list_head $shm_list_head
	search_showed false
	add_content /
	close_content /
	settings_content /
	Controls $mol_view
		sub <= controls /
	controls /
